/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SetsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      sets: this.store.findAll('milestones/set'),
      milestones: this.store.findAll('milestones/milestone'), // Loaded so that we can recursively (un)publish templates.
      milestoneSets: this.store.query('milestones/milestone-set', {
        include: 'milestones',
      }),
      schools: this.store.findAll('school'),
      schoolGroups: this.store.findAll('schools/group'),
      usageSets: this.store.findAll('schools/usage-set'),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
